import React from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import { smallestToBaseUnitCurrencyFormat } from '../../payment/utils';

export function SummaryTotal({ text, value }) {
  return (
    <React.Fragment>
      <Divider style={{ height: 2 }} />
      <ListItem divider>
        <div
          style={{
            flex: 1,
            fontWeight: 'bold',
          }}
        >
          {text}
        </div>
        <div
          style={{
            fontWeight: 'bold',
          }}
        >
          {smallestToBaseUnitCurrencyFormat(value) + ' CHF'}
        </div>
      </ListItem>
    </React.Fragment>
  );
}

export function SummaryItem({
  text,
  value,
  variant,
  displayAsCurrency = true,
}) {
  return (
    <React.Fragment>
      {variant === 'subtotal' && <Divider style={{ marginTop: 2 }} />}
      <ListItem divider>
        <div
          style={{
            flex: 1,
            fontWeight: variant === 'subtotal' ? 'bold' : 'inherit',
          }}
        >
          {text}
        </div>
        <div
          style={{
            fontWeight: variant === 'subtotal' ? 'bold' : 'inherit',
            color: variant === 'storno' ? 'red' : 'inherit',
          }}
        >
          {displayAsCurrency
            ? smallestToBaseUnitCurrencyFormat(value) + ' CHF'
            : value}
        </div>
      </ListItem>
    </React.Fragment>
  );
}

export default function ReportSummary({ title, children }) {
  return (
    <React.Fragment>
      <Typography variant="subheading" color="textPrimary">
        {title}
      </Typography>
      <List>{children}</List>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/views/reports/components/ReportSummary.jsx